import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { shouldFireCheckoutGoogleTag } from "@/lib/googleTagEligibility";

/* eslint-disable @typescript-eslint/no-explicit-any */
const w = window as any;

const FB_PIXEL_ID = "1631810208083007";
const PINTEREST_TAG_ID = "1631810208083007";
const GOOGLE_ADS_REMARKETING_ID = "AW-881417624";
const TIKTOK_PIXEL_ID = "D6LVE5BC77U5049K0P6G";
const X_PIXEL_ID = "r8o6r";

let fbPixelLoaded = false;
let pinterestLoaded = false;
let googleAdsRemarketingLoaded = false;
let tiktokLoaded = false;
let xPixelLoaded = false;

function loadFacebookPixel() {
  if (fbPixelLoaded || typeof window === "undefined") return;
  fbPixelLoaded = true;
  /* eslint-disable */
  (function (f: any, b, e, v, n?: any, t?: any, s?: any) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = "2.0";
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
  /* eslint-enable */
  w.fbq("init", FB_PIXEL_ID);
  w.fbq("track", "PageView");
}

function loadPinterestTag() {
  if (pinterestLoaded || typeof window === "undefined") return;
  pinterestLoaded = true;
  /* eslint-disable */
  if (!w.pintrk) {
    const pintrk: any = function () {
      pintrk.queue.push(Array.prototype.slice.call(arguments));
    };
    pintrk.queue = [];
    pintrk.version = "3.0";
    w.pintrk = pintrk;
    const t = document.createElement("script");
    t.async = true;
    t.src = "https://s.pinimg.com/ct/core.js";
    const r = document.getElementsByTagName("script")[0];
    r.parentNode!.insertBefore(t, r);
  }
  /* eslint-enable */
  w.pintrk("load", PINTEREST_TAG_ID);
  w.pintrk("page");
}

function loadGoogleAdsRemarketing() {
  if (googleAdsRemarketingLoaded || typeof window === "undefined") return;
  googleAdsRemarketingLoaded = true;
  // gtag.js is already loaded in index.html for AW-881417624.
  // Just push the config so remarketing fires on checkout entry.
  if (typeof w.gtag === "function") {
    w.gtag("config", GOOGLE_ADS_REMARKETING_ID);
  }
}

function loadTikTokPixel() {
  if (tiktokLoaded || typeof window === "undefined") return;
  tiktokLoaded = true;
  /* eslint-disable */
  (function (w: any, d, t) {
    w.TiktokAnalyticsObject = t;
    const ttq: any = (w[t] = w[t] || []);
    ttq.methods = ["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie","holdConsent","revokeConsent","grantConsent"];
    ttq.setAndDefer = function (t: any, e: any) { t[e] = function () { t.push([e].concat(Array.prototype.slice.call(arguments, 0))); }; };
    for (let i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]);
    ttq.instance = function (t: any) { const e = ttq._i[t] || []; for (let n = 0; n < ttq.methods.length; n++) ttq.setAndDefer(e, ttq.methods[n]); return e; };
    ttq.load = function (e: any, n: any) {
      const r = "https://analytics.tiktok.com/i18n/pixel/events.js";
      ttq._i = ttq._i || {}; ttq._i[e] = []; ttq._i[e]._u = r;
      ttq._t = ttq._t || {}; ttq._t[e] = +new Date();
      ttq._o = ttq._o || {}; ttq._o[e] = n || {};
      const s = document.createElement("script");
      s.type = "text/javascript"; s.async = true; s.src = r + "?sdkid=" + e + "&lib=" + t;
      const x = document.getElementsByTagName("script")[0];
      x.parentNode!.insertBefore(s, x);
    };
    ttq.load(TIKTOK_PIXEL_ID);
    ttq.page();
  })(window, document, "ttq");
  /* eslint-enable */
}

function loadXPixel() {
  if (xPixelLoaded || typeof window === "undefined") return;
  xPixelLoaded = true;
  /* eslint-disable */
  (function (e: any, t, n, s?: any, u?: any, a?: any) {
    if (e.twq) return;
    s = e.twq = function () { s.exe ? s.exe.apply(s, arguments) : s.queue.push(arguments); };
    s.version = "1.1"; s.queue = [];
    u = t.createElement(n); u.async = true; u.src = "https://static.ads-twitter.com/uwt.js";
    a = t.getElementsByTagName(n)[0]; a.parentNode.insertBefore(u, a);
  })(window, document, "script");
  /* eslint-enable */
  w.twq("config", X_PIXEL_ID);
  w.twq("track", "PageView");
}

function fireCheckoutPixels() {
  loadFacebookPixel();
  loadPinterestTag();
  loadGoogleAdsRemarketing();
  loadTikTokPixel();
  loadXPixel();

  // For subsequent navigations back to /checkout, also fire PageView events
  if (typeof w.fbq === "function") {
    w.fbq("track", "PageView");
  }
  if (typeof w.pintrk === "function") {
    w.pintrk("page");
  }
  if (typeof w.gtag === "function") {
    w.gtag("config", GOOGLE_ADS_REMARKETING_ID, {
      page_path: window.location.pathname,
      page_location: window.location.href,
    });
  }
  if (w.ttq && typeof w.ttq.page === "function") {
    w.ttq.page();
  }
  if (typeof w.twq === "function") {
    w.twq("track", "PageView");
  }
}

// Routes where social pixels (FB / Pinterest / TikTok / X) SHOULD fire.
// Allowlist approach: only car detail pages, checkout, and booking confirmation.
// Homepage, city landing pages, blog, legal, admin, etc. are excluded.
function shouldFireSocialPixels(path: string): boolean {
  return (
    path === "/checkout" ||
    path === "/booking-confirmation" ||
    path.startsWith("/checkout/") ||
    path.startsWith("/booking-confirmation/") ||
    path.startsWith("/car/")
  );
}

function getCheckoutTrackingPayload() {
  try {
    const stored = sessionStorage.getItem("fsta_booking_data");
    if (!stored) return { shouldFireGoogleTag: false };

    const parsed = JSON.parse(stored) as { pickupDate?: string; dropoffDate?: string };
    const pickupDate = parsed.pickupDate ? new Date(parsed.pickupDate) : undefined;
    const dropoffDate = parsed.dropoffDate ? new Date(parsed.dropoffDate) : undefined;

    if (!pickupDate || !dropoffDate || Number.isNaN(pickupDate.getTime()) || Number.isNaN(dropoffDate.getTime())) {
      return { shouldFireGoogleTag: false };
    }

    const diffTime = dropoffDate.getTime() - pickupDate.getTime();
    const rentalDays = Math.max(1, Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1);

    return {
      shouldFireGoogleTag: shouldFireCheckoutGoogleTag(pickupDate, rentalDays),
      pickupDate: pickupDate.toISOString(),
      rentalDays,
    };
  } catch {
    return { shouldFireGoogleTag: false };
  }
}

/**
 * Fires PageView events for all tracking pixels on every SPA route change.
 * Initial page load is handled by index.html scripts — we skip the first render.
 */
const PageViewTracker = () => {
  const location = useLocation();
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    const url = window.location.href;
    const path = location.pathname;
    const isCheckoutPage = path === "/checkout";
    const checkoutTracking = isCheckoutPage ? getCheckoutTrackingPayload() : null;
    const shouldFireGoogleTag = !isCheckoutPage || checkoutTracking?.shouldFireGoogleTag === true;

    // Google Ads / gtag — config fires on every page
    if (typeof w.gtag === "function") {
      w.gtag("config", "AW-881417624", { page_path: path, page_location: url });
    }

    // Conversion event — only fire on checkout when eligible (4+ days,
    // and summer rentals only when booked during the same year's summer)
    if (typeof w.gtag === "function" && isCheckoutPage && checkoutTracking?.shouldFireGoogleTag === true) {
      w.gtag("event", "conversion", {
        send_to: "AW-881417624/QjoSCJjO7Z8cEJi7paQD",
      });
    }

    // Google Tag Manager dataLayer
    if (Array.isArray(w.dataLayer)) {
      w.dataLayer.push({
        event: "virtualPageview",
        page: path,
        pageUrl: url,
        pageTitle: document.title,
        googleTagAllowed: shouldFireGoogleTag,
        ...(isCheckoutPage ? checkoutTracking : {}),
      });
    }

    // Meta Pixel — managed via GTM

    // Social pixels (Facebook, Pinterest, TikTok, X) — fire on all car-related
    // pages. Eligibility rules (4+ days / summer-only) are temporarily disabled
    // for these pixels; the rule code is preserved for future re-enable.
    // Google Ads remarketing config still piggybacks on fireCheckoutPixels.
    if (shouldFireSocialPixels(path)) {
      fireCheckoutPixels();
    }
  }, [location.pathname]);

  // On initial page load: fire conversion on /checkout when eligible, and
  // fire social pixels on every car page (rules disabled).
  useEffect(() => {
    const path = window.location.pathname;
    const isCheckoutPage = path === "/checkout";
    const checkoutTracking = isCheckoutPage ? getCheckoutTrackingPayload() : null;

    // Fire conversion event on direct checkout load when eligible
    if (isCheckoutPage && typeof w.gtag === "function" && checkoutTracking?.shouldFireGoogleTag === true) {
      w.gtag("event", "conversion", {
        send_to: "AW-881417624/QjoSCJjO7Z8cEJi7paQD",
      });
    }

    // Social pixels fire on every car-related page on initial load.
    // Duration/season rules intentionally bypassed (kept in code for re-enable).
    if (shouldFireSocialPixels(path)) {
      fireCheckoutPixels();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default PageViewTracker;
